import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from 'src/app/common/store/generic.selectors';
import { PageResult } from '../../types';
import {
  CurrentUserModel,
  User,
  UserConnectionHistory,
  userFeatureKey,
} from './type';
import { IUserState } from './user.reducer';
import { Action } from '../view/types';

const userFeatureState = createFeatureSelector<IUserState>(userFeatureKey);

export const userSelectors = {
  getById: createApiCallSelectors<User, IUserState>(
    userFeatureState,
    'getById',
  ),
  getMainSalesTeamById: createApiCallSelectors<number | undefined, IUserState>(
    userFeatureState,
    'getMainSalesTeamById',
  ),
  add: createApiCallSelectors<User, IUserState>(userFeatureState, 'add'),
  update: createApiCallSelectors<User, IUserState>(userFeatureState, 'update'),
  lockout: createApiCallSelectors<boolean, IUserState>(
    userFeatureState,
    'lockout',
  ),
  getCurrentUser: createApiCallSelectors<CurrentUserModel, IUserState>(
    userFeatureState,
    'getCurrentUser',
  ),
  getConnectionHistoriesById: createApiCallSelectors<
    UserConnectionHistory[],
    IUserState
  >(userFeatureState, 'getConnectionHistoriesById'),
  getStatusActions: createApiCallSelectors<Action[], IUserState>(
    userFeatureState,
    'getStatusActions',
  ),
};
